module.exports = __webpack_public_path__ + "img/综合工单.16542669.png";